<template>
    <v-sheet>
        <resume-personal-information v-model="form.resume" @input="emit" />
        <resume-name v-model="form.resume" class="mt-40 mt-lg-60" @input="emit" />
        <resume-education v-model="form.resume" class="mt-40 mt-lg-60" @input="emit" />
        <resume-work-experience v-model="form.resume" class="mt-40 mt-lg-60" @input="emit" />
        <resume-hash-tags v-model="form.resume" v-bind="{ hashTags }" class="mt-40 mt-lg-60" @input="emit" />
        <resume-languages v-model="form.resume" class="mt-40 mt-lg-60" @input="emit" />
        <resume-office-skills v-model="form.resume" class="mt-40 mt-lg-60" @input="emit" />
        <resume-certifications v-model="form.resume" class="mt-40 mt-lg-60" @input="emit" />
        <resume-cover-letter v-model="form.resume" class="mt-40 mt-lg-60" @input="emit" />
    </v-sheet>
</template>

<script>
import { initExpoEmployee } from "@/assets/variables/inits";

import ResumeName from "@/components/client/resume/resume-name.vue";
import ResumeHashTags from "@/components/client/resume/resume-hash-tags.vue";
import ResumeEducation from "@/components/client/resume/resume-education.vue";
import ResumeLanguages from "@/components/client/resume/resume-languages.vue";
import ResumeCoverLetter from "@/components/client/resume/resume-cover-letter.vue";
import ResumeOfficeSkills from "@/components/client/resume/resume-office-skills.vue";
import ResumeCertifications from "@/components/client/resume/resume-certifications.vue";
import ResumeWorkExperience from "@/components/client/resume/resume-work-experience.vue";
import ResumePersonalInformation from "@/components/client/resume/resume-personal-information.vue";

export default {
    components: {
        ResumeName,
        ResumeHashTags,
        ResumeEducation,
        ResumeLanguages,
        ResumeCoverLetter,
        ResumeOfficeSkills,
        ResumeCertifications,
        ResumeWorkExperience,
        ResumePersonalInformation,
    },
    props: {
        value: { type: Object, default: initExpoEmployee }, // form
        hashTags: { type: Array, default: () => [] },
    },
    data: () => ({
        form: initExpoEmployee(),
    }),
    methods: {
        sync() {
            this.form = initExpoEmployee(this.value);
        },
        emit() {
            this.$emit("input", this.form);
        },
    },
    watch: {
        value() {
            this.sync();
        },
    },
    mounted() {
        this.sync();
    },
};
</script>
